// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"175a1511","845":"377102a8"}[chunkId] + ".chunk.js";
};